import {combineReducers} from "redux";
import lockNumber from "./locknumber";
import lockNumberByUser from "./lockNumberByUser";
import lockBetTemplate from "./lockBetTemplate";
import hasLotteryTemplate from "./hasLotteryTemplate";
import resultBot from "./resultBot";

const bettingConfigReducer = combineReducers({
    lockNumber,
    lockNumberByUser,
    lockBetTemplate,
    hasLotteryTemplate,
    resultBot
});

export default bettingConfigReducer;
